export class DestinationModel {
  public id: number;
  public slug: string;
  public name: string;
  public latitude: string;
  public longitude: string;
  public photo: string;
  public totalPackages: number;

  constructor(obj: any) {
    this.id = obj.id ? obj.id : 0;
    this.slug = obj.slug ? obj.slug : "";
    this.name = obj.name ? obj.name : "";
    this.latitude = obj.latitude ? obj.latitude : "";
    this.longitude = obj.longitude ? obj.longitude : "";
    this.photo = obj.photo ? obj.photo : "";
    this.totalPackages = obj.totalPackages ? obj.totalPackages : 0;
  }
}